import React from 'react';
import LinearProgress from '@mui/material/LinearProgress';
import styled from '@emotion/styled';
// import { Children } from 'react';
// import theme from './theme';

export const MyProgressBar = ({ color, value}) => {
    const ProgressBar = styled(LinearProgress)(({ theme }) => ({
        height: 10,
        borderRadius: 5,
        })
    );
    return (
        <ProgressBar value={value} variant='determinate' color={color} />
    )
}